import React, { useState } from 'react';
import Dashboard from './components/Dashboard';
import MaintenanceForm from './components/MaintenanceForm';
import CarForm from './components/CarForm';
import './styles/global.css';

function App() {
  const [userId] = useState(1);
  const [selectedCarId, setSelectedCarId] = useState<number | null>(null);
  const [view, setView] = useState<'dashboard' | 'form-maintenance' | 'form-car'>('dashboard');

  const handleAddService = (carId: number) => {
    setSelectedCarId(carId);
    setView('form-maintenance');
  };

  const handleSuccess = () => {
    setView('dashboard');
    // Si teníamos un auto seleccionado, mantenemos la cabina abierta
    // El selectedCarId ya está seteado por handleAddService
  };

  return (
    <div className="App">
      <nav style={{ padding: '1rem', borderBottom: '1px solid var(--border)', marginBottom: '1rem' }}>
        <div className="container" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h2 style={{ color: 'var(--accent-color)' }}>Azulcito <span style={{ color: 'white', fontWeight: 'normal' }}>CarControl</span></h2>
          {view !== 'dashboard' && (
            <button className="btn btn-outline" onClick={() => setView('dashboard')}>Volver</button>
          )}
        </div>
      </nav>

      <main>
        {view === 'dashboard' && (
          <Dashboard 
            userId={userId} 
            onAddCar={() => setView('form-car')} 
            onAddService={handleAddService} 
          />
        )}
        
        {view === 'form-car' && (
          <div className="container">
            <CarForm userId={userId} onSuccess={handleSuccess} onCancel={() => setView('dashboard')} />
          </div>
        )}

        {view === 'form-maintenance' && (
          <div className="container">
            {selectedCarId && (
              <MaintenanceForm 
                carId={selectedCarId} 
                onSuccess={handleSuccess} 
                onCancel={() => setView('dashboard')} 
              />
            )}
          </div>
        )}
      </main>

      <footer style={{ marginTop: '4rem', padding: '2rem', textAlign: 'center', color: 'var(--text-secondary)', borderTop: '1px solid var(--border)' }}>
        <p>Azulcito CarControl &copy; 2026</p>
      </footer>
    </div>
  );
}

export default App;
